import { useEffect, useState } from "react";
import { Send, Trash2, CheckCircle2, XCircle } from "lucide-react";
import { http, errMsg, fmtDateTime } from "../api";

export default function ArtistTelegram() {
  const [t, setT] = useState(undefined);
  const [form, setForm] = useState({ bot_token: "", chat_id: "", label: "My Telegram" });
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => http.get("/artists/me/telegram").then(r => setT(r.data));
  useEffect(() => { load(); }, []);

  const save = async e => {
    e.preventDefault(); setBusy(true); setNotice(null);
    try {
      const { data } = await http.post("/artists/me/telegram", form);
      setNotice(data.test_ok ? { tone: "success", text: "Connected! Check Telegram — a welcome message was sent." } : { tone: "error", text: `Saved, but Telegram rejected the test message: ${data.test_error}. Check token & chat id.` });
      setForm({ bot_token: "", chat_id: "", label: "My Telegram" }); load();
    } catch (e) { setNotice({ tone: "error", text: errMsg(e) }); } finally { setBusy(false); }
  };
  const remove = async () => { await http.delete("/artists/me/telegram"); setNotice({ tone: "success", text: "Telegram disconnected" }); load(); };

  if (t === undefined) return <div className="empty">Loading…</div>;
  return (
    <>
      <div className="page-head"><div><h1>Telegram alerts</h1><p>Get an instant message for every new hire request, deadline decision, revision and approval.</p></div></div>
      {notice && <div className={`notice ${notice.tone}`} data-testid="artist-tg-notice">{notice.text}</div>}
      {t && (
        <div className={`list-row ${t.last_error ? "danger-border" : ""}`} style={{ marginBottom: 14 }} data-testid="artist-tg-connected">
          <div style={{ width: 42, height: 42, borderRadius: 10, background: "var(--primary-soft)", color: "var(--primary)", display: "grid", placeItems: "center" }}><Send size={18} /></div>
          <div className="list-row-info">
            <h3>{t.label} · chat {t.chat_id}</h3>
            <p>Bot {t.bot_token_masked} · {t.sent_count || 0} alerts sent · last {t.last_sent_at ? fmtDateTime(t.last_sent_at) : "never"}</p>
            {t.last_error ? <small style={{ color: "var(--danger)" }}><XCircle size={11} style={{ display: "inline" }} /> {t.last_error}</small> : <small style={{ color: "var(--success)" }}><CheckCircle2 size={11} style={{ display: "inline" }} /> Working</small>}
          </div>
          <button className="pill-action reject" onClick={remove} data-testid="artist-tg-remove"><Trash2 size={13} /> Disconnect</button>
        </div>
      )}
      <div className="form-card">
        <h2>{t ? "Replace connection" : "Connect your Telegram"}</h2>
        <div className="form-notice">
          <strong>3 easy steps:</strong> 1) In Telegram open <b>@BotFather</b> → send <code>/newbot</code> → copy the token. 2) Open your new bot and press <b>Start</b>. 3) Visit <code>https://api.telegram.org/bot&lt;TOKEN&gt;/getUpdates</code> and copy the number after <code>"chat":{"{"}"id":</code>.
        </div>
        <form onSubmit={save}>
          <div><label>Bot token *</label><input required value={form.bot_token} onChange={e => setForm({ ...form, bot_token: e.target.value })} placeholder="123456789:AAH…" data-testid="artist-tg-token" /></div>
          <div className="field-row">
            <div><label>Chat ID *</label><input required value={form.chat_id} onChange={e => setForm({ ...form, chat_id: e.target.value })} placeholder="123456789" data-testid="artist-tg-chat" /></div>
            <div><label>Label</label><input value={form.label} onChange={e => setForm({ ...form, label: e.target.value })} /></div>
          </div>
          <button className="primary" type="submit" disabled={busy} data-testid="artist-tg-save"><Send size={14} /> {busy ? "Connecting…" : "Connect & send test"}</button>
        </form>
      </div>
    </>
  );
}
